import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-moa-frame-box',
			_ctx.endpointId,
			{ 'is-not-active': _ctx.endpointId !== _ctx.activeFrame }
		])
  }, [
    _createVNode(_component_lyra_asset, {
      "asset-key": `moa-frame-box-${_ctx.endpointId}`
    }, null, 8, ["asset-key"])
  ], 2))
}